export default __webpack_public_path__ + "static/media/home1-banner1.a107a828.jpg";